import { useViewport } from 'components/general/useViewPort';
import React, { useMemo } from "react";
import Competitor from 'components/presentation/Competitor';
import { NocMemo as Noc } from 'components/presentation/Noc';
import Label from "components/general/Label"
import { ColumnExpander, ColumnNameH2H } from "components/common/TableColumns"
import StatsBox from "components/sports/gbl/views/StatsBox"
import { dateFormat } from "helpers/utils"
import { findArray } from 'helpers/utils'
import LoaderSubComponent from "components/general/LoaderSubComponent";
import MirsTable from "components/general/table/Table";
import { capitalize } from 'helpers/utils'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import SportCode from 'components/common/SportCode';

const TableColumns = () => {
  return (
    [
      ColumnBib({ disableSort: true, label: 'HeaderNumber', headerClassName: 'text-end w-5' }),
      ColumnNameH2H({ showCaptainAbbr: true, showSuspendedCode: false, hideNoc: true }),
      ColumnExpander({ type: 'alwaysTrue', idNode: 'athlete' })
    ]
  )
}


export function ColumnBib({
  disableSort = false,
  className = 'text-end',
  headerClassName = 'text-end w-5 text-nowrap',
  label = 'HeaderBib',
  expecialCase = false,
  remove = false
}) {
  return (
    {
      Header: <Label data={label} />,
      accessor: 'bib',
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort,
      id: 'Bib',
      remove: remove,
    }
  )
}

const getConfigurationBox = (date) => {

  const formatedDate = date ? dateFormat(date, "", "D MMM H:mm") : "";

  let configuration = {
    header: `Competition Statistics - ${formatedDate}`,
    stats: [
      {
        order: 1,
        code: 'MINS',
        attr: 'value',
        label: 'stat_1',
        title: 'Minutes Played'
      },
      {
        order: 2,
        code: 'SHOT',
        attr: 'value',
        label: 'stat_2',
        title: 'Throws - Goals'
      },
      {
        order: 3,
        code: 'SHOT',
        label: 'stat_3',
        title: 'Throws - Penalties ayuda aqui',
        codeExt: 'PTY',
        attrExt: 'value'
      },
      {
        order: 4,
        code: 'SHOT',
        attr: 'attempt',
        label: 'stat_4',
        title: 'Throws - Throws'
      },
      {
        order: 5,
        code: 'PTY',
        attr: 'value',
        label: 'stat_5',
        title: 'Penalty Throws - Goals'
      },
      {
        order: 6,
        code: 'PTY',
        label: 'stat_6',
        title: 'Penalty Throws - Penalties',
        codeExt: 'PTY',
        attrExt: 'value'
      },
      {
        order: 7,
        code: 'PTY',
        attr: 'attempt',
        label: 'stat_7',
        title: 'Penalty Throws - Throws'
      },
      {
        order: 8,
        code: 'SHOT_EXTRA',
        attr: 'value',
        label: 'stat_8',
        title: 'Extra - Goals'
      },
      {
        order: 9,
        code: 'SHOT_EXTRA',
        attr: 'attempt',
        label: 'stat_9',
        title: 'Extra - Throws'
      },
      {
        order: 10,
        code: 'TOT',
        attr: 'value',
        label: 'stat_10',
        title: 'Total - Goals'
      },
      {
        order: 11,
        code: 'TOT',
        label: 'stat_11',
        codeExt: 'PTY',
        attrExt: 'value',
        title: 'Total - Penalties'
      },
      {
        order: 12,
        code: 'TOT',
        attr: 'attempt',
        label: 'stat_12',
        title: 'Total - Throws'
      },
      {
        order: 13,
        code: 'PTY_M',
        attr: 'value',
        label: 'stat_13',
        title: 'Penalties Made'
      },
      {
        order: 14,
        code: 'OG',
        attr: 'value',
        label: 'stat_14',
        title: 'Own Goals'
      },
      {
        order: 15,
        code: 'BLC',
        attr: 'value',
        label: 'stat_15',
        title: 'Blocks'
      },
      {
        order: 16,
        code: 'BO',
        attr: 'value',
        label: 'stat_16',
        title: 'Ball Over'
      },
      {
        order: 17,
        code: 'PO',
        attr: 'value',
        label: 'stat_17',
        title: 'Pass Over'
      }
    ]
  }
  return configuration;
}

const getConfiguration = (data, breakPoint) => {
  let configuration = {
    columns: [],
    subComponent: null,
    caption: null,
    hiddenColumns: [],
    sortBy: [],
    configs: {
    }
  };

  configuration.captionStarters = (
    <div className="d-flex justify-content-between">
      <div className='d-flex align-items-center'>
        <div className='d-none d-md-block me-1'>
          <Noc className='me-1' {...data?.participant?.organisation} />
        </div>
        <strong>
          <Competitor hidePicture={true} {...data?.participant} />
        </strong>
      </div>
      <div>
        <Uniform data={data} />
      </div>
    </div>
  )
  configuration.columns = TableColumns();

  return configuration;
}

const Uniform = ({ data }) => {
  const uniform = capitalize(data?.eventUnitEntries?.find(i => i?.eue_code === 'UNIFORM')?.eue_value);
  return (
    <>
      <div className='me-5'>
        <Label data="HeaderShirt" />: {uniform}
      </div>
    </>
  )
}

const StartListSide = ({ data, resultStatus, config, date }) => {
  const { mirs_rsc } = useUrlFriendlyToParameters();
  const { breakPoint } = useViewport();

  const configEvent = useMemo(() => getConfiguration(data, breakPoint));

  const configBox = useMemo(() => getConfigurationBox(date));

  const renderRowSubComponent = React.useCallback(({ row }) => (
    <LoaderSubComponent component={
      <StatsBox data={row?.original} config={configBox} breakPoint={breakPoint} />
    }
    />
  ), [resultStatus]);

  const starters = data?.teamAthletes

  return (<>
    {data?.teamAthletes && (
      <div className="start-list-side-main">
        <div className="row">
          <div className="col-12">
            <MirsTable
              className={"table-start-list"}
              id={`mirs-table-start-list-starters-${mirs_rsc}-${data?.participant?.code}`}
              data={starters}
              columns={configEvent.columns}
              renderRowSubComponent={renderRowSubComponent}
              keyRow='athlete-code'
              caption={configEvent.captionStarters}
              initialSortBy={configEvent.sortBy}
            />
          </div>

        </div>
      </div>
    )
    }
  </>)
}

export default StartListSide;
